import styled from 'styled-components';
import { Layout, Menu } from 'antd';

export const LogoContainer = styled.div``;

export const LogoHeader = styled.div`
  // height: 42px;
  margin: 14px 22px 8px;
  display: flex;
  cursor: pointer;

  & img {
    width: 35px;
    height: 35px;
    border-radius: 21px;
  }
`;

export const UserContainer = styled.div`
  display: flex;
`;

export const UserInfoContainer = styled.div`
  margin-left: 12px;
`;

export const RegularText = styled.h2`
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: white;
  margin-left: 10px;
  margin-bottom: 0;
`;

export const PrimaryText = styled.h2`
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: @primary-text;
  margin: 0;
  margin-left: 10px;
`;

export const LogoText = styled(PrimaryText)`
  min-width: 100px;
  margin-top: 15px;
  color: white;
  transition: opacity 400ms;
`;

export const LabelName = styled.label`
  width: 69px;
  height: 22px;
  font-family: Lato;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
`;

export const MenuItem = styled(Menu.Item)`
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  border-bottom-color: #d8dde6;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  margin: 10px 24px 10px 24px;
`;

export const SiderContainer = styled(Layout.Sider)`
  height: 100vh;
  position: fixed;
  left: 0;
  background-color: #353a40;
  overflow: auto;
  overflow-x: hidden;
  z-index: 2;

  & .ant-menu-item > .anticon,
  .ant-menu-submenu-title > .anticon,
  .ant-menu-item:hover > label,
  .ant-menu-item-selected label,
  .ant-menu-item-selected span,
  .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
  .ant-menu-submenu:hover > .ant-menu-submenu-title > span > label {
    color: #fff;
  }
`;
